<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchInvoicePayoffOther">
                    <date-picker
                        v-model="search.date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด">
                    </date-picker>
                    &nbsp;
                    <input type="text" class="form-control" placeholder="รหัสบัญชี"
                           v-model="search.account_number"/>
                    &nbsp;
                    <input type="text" class="form-control" placeholder="เลข RVO"
                           v-model="search.rvo"/>
                    &nbsp; &nbsp;
                    <button type="button" class="btn btn-success"
                            @click="searchInvoicePayoffOther">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-warning"
                            @click="goToInvoicePayoffOtherForm(null,null)">
                        <icon name="plus"></icon>
                        ตัดชำระอื่นๆ
                    </button>
                </form>
            </div>
        </nav>

        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th>เลข RVO</th>
                    <th>วันที่</th>
                    <th>ลูกค้า</th>
                    <th>ขาย</th>
                    <th>ยอดเงิน</th>
                    <th>ช่องทางการชำระเงิน</th>
                    <th>วันที่บันทึกรับ</th>
                    <th>ผู้บันทึกรับ</th>
                    <th>ผู้แก้ไข</th>
                    <th>สถานะ</th>
                    <th>ดูข้อมูล</th>
                    <th>พิมพ์</th>
                    <th>ยกเลิก</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in table_list">
                    <td>
                        <template v-if="data.rvo_number">
                            {{ data.rvo_number }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.date">
                            {{ data.date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.customer">
                            {{ data.customer.store_name ? data.customer.store_name : data.customer.first_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-for="item in data.other_details">
                            <div>-{{ item.account ? item.account.name : '' }}</div>
                        </template>
                    </td>
                    <td>
                        <template v-if="data.total">
                            {{ data.total | currency }}
                        </template>
                    </td>
                    <td>
                        <template v-if="data.transactions.length > 0" v-for="trans in data.transactions">
                            -{{ trans.transaction_type.name }}<br>
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        {{ data.created_at | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.user_update">
                            {{ data.user_update.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a v-if="data.payoff_status_id == 1" style="color: #00a699">
                            ตัดชำระแล้ว
                        </a>
                        <a v-else-if="data.payoff_status_id == 2" style="color: red">
                            ยกเลิกแล้ว
                        </a>
                        <a @click="goToInvoicePayoffOtherForm(data.id , 2)" v-else
                           style="text-decoration: underline; color: red;">
                            รอการตัดชำระ
                        </a>
                    </td>
                    <td>
                        <button class="btn btn-primary" type="button"
                                @click="goToInvoicePayoffOtherForm(data.id , data.payoff_status_id)">
                            <icon name="pencil-alt"></icon>
                            ดูข้อมูล
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-info" type="button" @click="printInvoicePayoffOther(data.id)">
                            <icon name="print"></icon>
                            พิมพ์ข้อมูล
                        </button>
                    </td>
                    <td>
                        <button v-if="data.payoff_status_id == 0" class="btn btn-danger" type="button"
                                @click="cancelPO(data.id)">
                            <icon name="trash"></icon>
                            ยกเลิก
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getPage">
            </vue-pagination>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_modal">
            <div style="text-align: center;">
                <h4>คุณต้องการยกเลิกใช่หรือไม่?</h4>
                <br/>
                <button @click="deletePO"
                        type="button"
                        class="btn btn-success mt-2">
                    ตกลง
                </button>
                &nbsp;&nbsp;
                <button
                    type="button"
                    @click="hideDeleteModal"
                    class="btn btn-outline-secondary mt-2">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert-primary">{{table_list}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {domain} from "../../../util/Constants";
import Loading from "../../Utility/Loading";

export default {
    components: {Loading, VuePagination, DatePicker},
    name: "invoice-payoff-other-list",
    created() {
        this.$store.dispatch("InvoicePayoff/getInvoicePayoffOtherList")
    },
    data() {
        return {
            page: 1,
            msg: '',
            status_loading: 1,
            search: {
                date: [],
                account_number: '',
                rvo: '',
            },
            deleted_id: '',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            table_list: state => {
                return state.InvoicePayoff.invoice_payoff_other_list
            },
            dataPaginate: state => {
                return state.InvoicePayoff.dataPaginateOther
            },
            user: state => {
                return state.Auth.user;
            },
        })
    },
    methods: {
        hideDeleteModal() {
            this.$refs.delete_modal.hide();
        },
        cancelPO(id) {
            this.deleted_id = id;
            this.$refs.delete_modal.show();
        },
        deletePO() {
            this.$store.dispatch("InvoicePayoff/deleteInvoicePayoffOther", this.deleted_id)
            this.hideDeleteModal();
        },
        goToInvoicePayoffOtherForm(id, payoff_status_id) {
            if (id) {
                this.$store.dispatch("InvoicePayoff/showInvoicePayoffOther", id)
            } else {
                this.$store.dispatch("InvoicePayoff/clearDataForm");
                this.$store.dispatch("InvoicePayoff/clearTransaction");
            }
            this.$router.push({
                name: "invoice-payoff-other-form",
                params: {
                    payoff_status_id: payoff_status_id,
                    id: id
                }
            });
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            this.$store.dispatch("InvoicePayoff/getInvoicePayoffOtherList", this.page)
        },
        printInvoicePayoffOther(id) {
            // this.msg = "กำลังดาวโหลดรายงาน";
            // this.status_loading = 1;
            // this.showLoadingModal();
            window.open(domain + `/payoff-other-pdf/${id}?user=${this.user.name}`, '_blank');
            // this.$store.dispatch("InvoicePayoff/printInvoicePayoffOther",{
            //     id,
            //     user : this.user.name
            // }).then(url=>{
            //     if(url){
            //         window.open(url,'_blank')
            //         this.hideLoadingModal();
            //     }else{
            //         this.msg = "ไม่สามารถพิมพ์ RVO ได้";
            //         this.status_loading = 3;
            //         this.showLoadingModal();
            //     }
            // }).catch(()=>{
            //     this.msg = "ไม่สามารถพิมพ์ RVO ได้";
            //     this.status_loading = 3;
            //     this.showLoadingModal();
            // })
        },
        searchInvoicePayoffOther() {
            let start_date = "";
            let end_date = "";
            if (this.search.date.length > 0 && this.search.date[0]) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            let data = {
                start_date: start_date,
                end_date: end_date,
                account_number: this.search.account_number,
                rvo: this.search.rvo,
            };

            this.$store.dispatch("InvoicePayoff/searchInvoiceOther", data);
        }
    }
}
</script>

<style scoped>

</style>
